import { calc } from "./modules/calc"
import { forms } from "./modules/forms"
import { tabs } from "./modules/tabs"
import { timer } from "./modules/timer"
window.addEventListener('DOMContentLoaded',()=>{
    calc()
    forms()
    tabs()
    timer()
})